module.exports = __webpack_public_path__ + "media/hover.49f82ae5.mp3";